import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function challenge() {
  return (
    <section className="challenge_par client_truth p-100 text_second_text">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Client <span>Brief</span>
            </h2>
            <p>
              The client approached TekRevol with a pressing concern regarding
              the challenges of misinformation in the digital age.
            </p>
            <p>
              They envisioned TruthGPT as an AI chatbot mobile app focused on
              truth and transparency, incorporating blockchain technology and
              featuring a 3D character named Truthie.
            </p>
            <p>
              The primary objectives were to provide users with reliable
              information, assist in generating responses to text messages, and
              establish a secure and transparent platform.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-2 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/Client_Brief.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={620}
                height={717}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default challenge;
